/**  Список идентификаторов сервисов. */
export enum DiTokens {
  /**Сервис вывода сообщений клиенту */
  AlertService = "AlertService",

  /**Сервис обработки ошибок */
  ErrorService = "ErrorService",

  /** Сервис авторизации. */
  AuthService = "AuthService",

  /** Сервис настроек приложения */
  ConfigService = "ConfigService",

  /** Сервис работы со счетами. */
  ContractService = "ContractService",

  /** Сервис работы с картами. */
  CardService = "CardService",

  /** Сервис данных клиента */
  PersonService = "PersonService",

  /** Сервис каталога операций */
  CatalogService = "CatalogService",

  /** Сервис истории операций */
  OperationsHistoryService = "OperationsHistoryService",

  /** Сервис выписки по счету */
  ContractStatementService = "ContractStatementService",

  /** Сервис выписки по карте */
  CardStatementService = "CardStatementService",

  /**Сервис контроля сессии */
  SessionService = "SessionService",

  /**Сервис операции каталога */
  CatalogOperationService = "CatalogOperationService",

  /**Сервис смены пароля */
  ChangePasswordService = "ChangePasswordService",

  /** Настройки сбп */
  SbpEnableService = "SbpEnableService",

  /** Установка сбп по умолчанию */
  SbpDefaultService = "SbpDefaultService",

  /** Установка счета для зачислений по умолчанию */
  AccountInDefaultService = "AccountInDefaultService",

  /** Блокировка и разблокировка карты */
  CardBlockService = "CardBlockService",

  /** Блокировка и разблокировка карты */
  CardPinService = "CardPinService",

  /** Замена смс пакета */
  ContractSmsService = "ContractSmsService",

  /** Востановление пароля */
  RecoveryService = "RecoveryService",

  /** Регистрация */
  RegisterService = "RegisterService",

  /** Шаблоны */
  TemplatesService = "TemplatesService",

  /** Шаблоны редактирование */
  TemplateEditService = "TemplateEditService",

  /** Шаблоны создание */
  TemplateCreateService = "TemplateCreateService",

  /** Чат */
  ChatService = "ChatService",

  SbpDefaultOutService = "SbpDefaultOutService",

  SbpBankSelectService = "SbpBankSelectService",

  ServerCommandsService = "ServerCommandsService",

  SubscriptionService = "SubscriptionService",

  DownloadTemplates = "DownloadTemplates",

  CardLimitsService = "CardLimitsService",

  EsiaAuthService = "EsiaAuthService",
  BarcodeOperationService = "BarcodeOperationService",
  C2BBindingOperationService = "C2BBindingOperationService"
}
